// extracted by mini-css-extract-plugin
export var selectItemWrapper = "styles-module--selectItemWrapper--iBLj7";
export var selectItem = "styles-module--selectItem--KcnKk";